'use strict';

var icon = {};

exports.__exports = icon;
//# sourceMappingURL=icon3.cjs.map
